import styled from '@xstyled/styled-components';

export const RightBorder = styled.div<{ highlightColor: string }>`
  background-color: ${p => p.highlightColor};
  padding: md;
  border-top-right-radius: 22px;
  border-bottom-right-radius: 22px;
  margin-left: 40px;
  height: 104px;
  width: 324px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    left: -32px;
    top: 0;
    width: 0;
    height: 0;
    border-top: 52px solid;
    border-left: 32px solid transparent;
    border-top-color: ${p => p.highlightColor};
  }

  &:before {
    content: '';
    position: absolute;
    left: -32px;
    bottom: 0;
    width: 0;
    height: 0;
    border-bottom: 52px solid;
    border-left: 32px solid transparent;
    border-bottom-color: ${p => p.highlightColor};
  }
`;
